'use strict';
import DropShipShippingAddressListController from './drop-ship-shipping-address-list.controller';
import DropShipShippingAddressListService from './drop-ship-shipping-address-list.service';
import ShippingAddressForm from '../forms/account/shipping-address';
import ngMaterial from 'angular-material';
import paging from '../paging';
export default angular.module('directives.dropShipShippingAddressList', [ShippingAddressForm, ngMaterial, 'dialog', paging])
    .service('DropShipShippingAddressListService', DropShipShippingAddressListService)
    .component('dropShipShippingAddressList', {
    template: require('./drop-ship-shipping-address-list.html'),
    controller: DropShipShippingAddressListController
})
    .name;
//# sourceMappingURL=index.js.map